module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-modal', {
    ref: "modal",
    attrs: {
      "visible": "",
      "size": "lg",
      "hide-footer": true,
      "title": "inkooporder controleren"
    },
    on: {
      "hidden": function($event) {
        _vm.$emit('close')
      }
    }
  }, [(_vm.scannedProduct === null) ? _c('div', {
    staticClass: "text-center p-50"
  }, [_c('div', {
    staticClass: "block-header block-header-default"
  }, [_c('h3', {
    staticClass: "block-title"
  }, [_vm._v("\n          Scan het in te boeken product...\n          ")])]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-spin fa-5x fa-spinner",
    staticStyle: {
      "margin-top": "100px"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "block-content",
    staticStyle: {
      "margin-top": "100px"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.completeOrderList
    }
  }, [_vm._v("Inkooporder afronden")])])]) : _c('div', [_c('div', {
    staticClass: "block-header block-header-default"
  }, [_c('h3', {
    staticClass: "block-title"
  }, [_vm._v("\n        Product uit inkooporde gescanned\n      ")])]), _vm._v(" "), _c('table', {
    staticClass: "table table-borderless table-striped table-hover",
    staticStyle: {
      "margin-left": "auto",
      "margin-right": "auto",
      "width": "90% !important"
    }
  }, [_c('tbody', [(_vm.scannedProduct.image_urls) ? _c('td', [_c('img', {
    staticClass: "img-avatar img-avatar48",
    attrs: {
      "src": _vm.scannedProduct.image_urls[0],
      "alt": ""
    }
  })]) : _vm._e(), _vm._v(" "), _c('td', [_c('a', {
    staticClass: "font-w600",
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.scannedProduct.name))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.scannedProduct.stock_quantity))]), _vm._v(" "), _c('td', [_c('location-editable', {
    key: _vm.scannedProduct.id,
    attrs: {
      "field": "location",
      "value": _vm.scannedProduct.location,
      "product-id": _vm.scannedProduct.id
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    staticClass: "form-inline",
    staticStyle: {
      "margin-left": "auto",
      "margin-right": "auto",
      "width": "75% !important"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticStyle: {
      "margin-right": "15px"
    },
    attrs: {
      "for": "amountDelivered"
    }
  }, [_vm._v("Aantal geleverd")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.deliveredAmount),
      expression: "deliveredAmount"
    }],
    staticClass: "form-control form-control-lg",
    staticStyle: {
      "margin-right": "15px"
    },
    attrs: {
      "type": "number",
      "id": "amountDelivered"
    },
    domProps: {
      "value": (_vm.deliveredAmount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.deliveredAmount = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.bookProduct
    }
  }, [_vm._v("Bij boeken")])])])])]), _vm._v(" "), (_vm.unkownProductScanned) ? _c('unkown-product-modal', {
    attrs: {
      "barcode": _vm.scannedBarcode
    },
    on: {
      "close": function($event) {
        _vm.unkownProductScanned = null, _vm.scannedBarcode = null
      },
      "unkownProductCreated": _vm.handleUnkownProductCreated
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b715d3d4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/order-lists/CheckOrderListModal.vue
// module id = 751
// module chunks = 1